import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconWhiteboard, IconWhiteboardHide } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { setOverflowMenuVisible } from '../../../toolbox/actions.web';
import { toggleWhiteboard } from '../../actions.web';
import { isWhiteboardButtonVisible, isWhiteboardVisible } from '../../functions';
/**
 * Component that renders a toolbar button for the whiteboard.
 */
class WhiteboardButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.showWhiteboard';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.hideWhiteboard';
    icon = IconWhiteboard;
    label = 'toolbar.showWhiteboard';
    toggledIcon = IconWhiteboardHide;
    toggledLabel = 'toolbar.hideWhiteboard';
    toggledTooltip = 'toolbar.hideWhiteboard';
    tooltip = 'toolbar.showWhiteboard';
    /**
     * Handles clicking / pressing the button, and opens / closes the whiteboard view.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(toggleWhiteboard());
        dispatch(setOverflowMenuVisible(false));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._toggled;
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    return {
        _toggled: isWhiteboardVisible(state),
        visible: isWhiteboardButtonVisible(state)
    };
}
export default translate(connect(_mapStateToProps)(WhiteboardButton));
